"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.length = exports.isArray = exports.isObject = exports.isString = exports.isBool = exports.isInteger = exports.isValidParametersObject = exports.isFunction = exports.isNumber = exports.isDate = exports.isValidId = exports.notNullOrZero = exports.notNullOrEmpty = exports.notNull = void 0;
const Platform_1 = __importDefault(require("../Platform"));
const Extensions_1 = __importDefault(require("./Extensions"));
function notNull(value, name) {
    if (Extensions_1.default.isNull(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("Validate_NotNullError"), name || "Value");
    }
}
exports.notNull = notNull;
function notNullOrEmpty(value, name) {
    if (Extensions_1.default.isNullOrEmpty(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("Validate_NotNullOrEmptyError"), name || "Value");
    }
}
exports.notNullOrEmpty = notNullOrEmpty;
function notNullOrZero(value, name) {
    if (Extensions_1.default.isNullOrZero(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("Validate_NotNullOrEmptyError"), name || "Value");
    }
}
exports.notNullOrZero = notNullOrZero;
function isValidId(value, name) {
    if (!Extensions_1.default.isValidId(value)) {
        throw new Error((name || "id") + ' "' + value + '" is not valid.');
    }
}
exports.isValidId = isValidId;
function isDate(value, name) {
    notNull(value, name);
    if (!Extensions_1.default.isDate(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("TypeCheckError"), name || "Value", "Date", typeof value);
    }
}
exports.isDate = isDate;
function isNumber(value, name) {
    notNull(value, name);
    if (!Extensions_1.default.isNumber(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("TypeCheckError"), name || "Value", "Number", typeof value);
    }
}
exports.isNumber = isNumber;
function isFunction(value, name) {
    if (!Extensions_1.default.isFunction(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("TypeCheckError"), name || "Value", "Function", typeof value);
    }
}
exports.isFunction = isFunction;
function isValidParametersObject(value, name) {
    notNull(value, name);
    isObject(value, name);
    for (var parameter in value) {
        if (parameter.indexOf("$") === 0) {
            throw Extensions_1.default.format(Platform_1.default.getResourceString("Validate_InvalidUserParameter"), name, parameter);
        }
    }
}
exports.isValidParametersObject = isValidParametersObject;
function isInteger(value, name) {
    notNull(value, name);
    isNumber(value, name);
    if (parseInt(value, 10) !== parseFloat(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("TypeCheckError"), name || "Value", "number", typeof value);
    }
}
exports.isInteger = isInteger;
function isBool(value, name) {
    if (!Extensions_1.default.isBool(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("TypeCheckError"), name || "Value", "number", typeof value);
    }
}
exports.isBool = isBool;
function isString(value, name) {
    if (!Extensions_1.default.isString(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("TypeCheckError"), name || "Value", "string", typeof value);
    }
}
exports.isString = isString;
function isObject(value, name) {
    if (!Extensions_1.default.isObject(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("TypeCheckError"), name || "Value", "object", typeof value);
    }
}
exports.isObject = isObject;
function isArray(value, name) {
    if (!Array.isArray(value)) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("TypeCheckError"), name || "Value", "array", typeof value);
    }
}
exports.isArray = isArray;
function length(value, length, name) {
    notNull(value, name);
    isInteger(length, "length");
    if (value.length !== length) {
        throw Extensions_1.default.format(Platform_1.default.getResourceString("Validate_LengthUnexpected"), name || "Value", length, value.length);
    }
}
exports.length = length;
exports.default = {
    notNull,
    notNullOrEmpty,
    notNullOrZero,
    isValidId,
    isDate,
    isNumber,
    isFunction,
    isValidParametersObject,
    isInteger,
    isBool,
    isString,
    isObject,
    isArray,
    length
};
